import React, { useCallback, useState } from "react"
import { useParams } from "react-router-dom"
import { gql, useMutation, useQuery } from "@apollo/client"

import { Layout } from "components"

const USER = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      displayName
      email
      phoneNumber
      role
      photoURL
    }
  }
`

const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      displayName
      email
      phoneNumber
      role
    }
  }
`

const DELETE_USER = gql`
  mutation UpdateUser($id: ID!) {
    deleteUser(id: $id) {
      id
    }
  }
`

const UserPage = () => {
  const { id } = useParams()

  const { data, loading, error } = useQuery(USER, { variables: { id } })
  const [updateUser] = useMutation(UPDATE_USER)
  const [deleteUser] = useMutation(DELETE_USER)

  const handleUserUpdate = async (input) => {
    try {
      await updateUser({ variables: { input } })
    } catch (error) {
      console.error(error)
    }
  }

  const handleUserDelete = async (id) => {
    try {
      await deleteUser({ variables: { id } })
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Layout title={data?.user?.displayName}>
      <Hero {...data?.user} />
    </Layout>
  )
}

export default UserPage

const Hero = ({ displayName, email, children }) => {
  return (
    <div className="w-full relative px-4 sm:px-6 lg:px-8 py-8 bg-gray-800 text-gray-100 pb-24">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 pt-3">
        <div className="flex items-center text-gray-100">
          <h1 className="mt-1 font-semibold text-4xl leading-normal">
            {displayName}
          </h1>
        </div>

        <div className="mt-1">
          <p className="text-xs text-gray-300 font-semibold uppercase tracking-wide leading-normal">
            {email}
          </p>
        </div>

        <div className="mt-">{children}</div>
      </div>
    </div>
  )
}
